import { TIMESHEET_STATUS_LABELS } from "../../api";
import type { Timesheet } from "../../api";
import { Badge } from "../../components";
import { formatDateTime } from "../../format";
import styles from "./Feuilles.module.css";

const TONS = {
  draft: "neutral",
  submitted: "warning",
  approved: "success",
  rejected: "danger",
} as const;

/** L'étiquette d'un statut de feuille, la même partout. */
export function StatutBadge({ statut, size = "md" }: { statut: Timesheet["status"]; size?: "sm" | "md" }) {
  return (
    <Badge tone={TONS[statut]} dot size={size}>
      {TIMESHEET_STATUS_LABELS[statut]}
    </Badge>
  );
}

/**
 * Le bandeau d'état d'une feuille : ce qu'elle est, depuis quand, et le motif
 * si elle a été refusée. `role="status"` : un changement de statut est
 * annoncé sans interrompre.
 */
export function FeuilleStatut({ feuille }: { feuille: Timesheet }) {
  return (
    <div className={styles.statut} role="status">
      <StatutBadge statut={feuille.status} />
      <span className={styles.statutTexte}>
        {feuille.status === "draft" && "Brouillon : les jours s'enregistrent au fil de la saisie, rien n'est envoyé."}
        {feuille.status === "submitted" &&
          feuille.submitted_at !== null &&
          `Soumise le ${formatDateTime(feuille.submitted_at)}, en attente de validation.`}
        {feuille.status === "approved" &&
          feuille.decided_at !== null &&
          `Approuvée le ${formatDateTime(feuille.decided_at)}.`}
        {feuille.status === "rejected" &&
          feuille.decided_at !== null &&
          `Refusée le ${formatDateTime(feuille.decided_at)} : corrigez puis soumettez à nouveau.`}
      </span>
      {feuille.status === "rejected" && feuille.rejection_reason !== null && (
        <blockquote className={styles.motif}>
          <span className={styles.motifTitre}>Motif du refus</span>
          {feuille.rejection_reason}
        </blockquote>
      )}
    </div>
  );
}
